import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrphanedDocumentResults } from '../../models/orphaned-documents/orphaned-document-results.interface';
import { OrphanedDocumentIndex } from '../../models/orphaned-documents/orphaned-document-index.interface';
import { OrphanedDocument } from '../../models/orphaned-documents/orphaned-document.interface';
import { OrphanedDocumentPatch } from '../../models/patch/orphaned-document.patch.interface';
import { HttpPatchUtilityService } from '../../utility/http-patch-utility/http-patch-utility.service';
import { HttpParamObject } from '../../utility/http-utility/http-param-object.interface';
import { HttpUtilityService } from '../../utility/http-utility/http-utility.service';

@Injectable({ providedIn: 'root' })
export class OrphanedDocumentsService {
	constructor(private readonly http: HttpClient) {}

	getOrphanedDocuments(
		index = 1,
		recordsPerPage = 10,
		documentTag = 'Unresolved',
		documentSource = 'All',
		emailTo = '-1'
	): Observable<OrphanedDocumentResults> {
		const queryParams: HttpParamObject = HttpUtilityService.toPlainHttpParams({
			index,
			recordsPerPage,
			documentTag,
			documentSource,
			emailTo
		});

		return this.http.get<OrphanedDocumentResults>(
			'orphaned-documents',
			queryParams
		);
	}

	getOrphanedDocument(id: number): Observable<OrphanedDocument> {
		return this.http.get<OrphanedDocument>(`orphaned-documents/${id}`);
	}

	serveOrphanedDocument(
		id: number,
		orphanedDocument: OrphanedDocument
	): Observable<HttpResponse<Blob>> {
		return this.http.post<any>(
			`orphaned-documents/${id}/download`,
			orphanedDocument,
			{
				responseType: 'blob' as 'json',
				observe: 'response'
			}
		);
	}

	patchOrphanedDocument(
		orphanedDocument: OrphanedDocument,
		orphanedDocumentPatch: OrphanedDocumentPatch
	): Observable<OrphanedDocument> {
		const patchOperation =
			HttpPatchUtilityService.convertDataToHttpPatchOperation(
				orphanedDocument,
				{ ...orphanedDocument, ...orphanedDocumentPatch }
			);

		return this.http.patch<OrphanedDocument>(
			`orphaned-documents/${orphanedDocument.id}`,
			patchOperation
		);
	}

	indexOrphanedDocument(
		id: number,
		documentIndexDTO: OrphanedDocumentIndex
	): Observable<void> {
		return this.http.post<void>(
			`orphaned-documents/${id}/index`,
			documentIndexDTO
		);
	}

	deleteOrphanedDocument(id: number): Observable<void> {
		return this.http.delete<void>(`orphaned-documents/${id}`);
	}

	getOrphanedDocumentToEmailAccounts(): Observable<Array<string>> {
		return this.http.get<Array<string>>('orphaned-documents/to-email-accounts');
	}
}
